import React, { useState } from "react";
import placeholderLogo from "assets/placeholder.png";
import timeIcon from "assets/appointment-icon-big.png";
import { KeyboardDatePicker } from "@material-ui/pickers";
import SuccessModal from "components/modals/successModal";
import { createAppointment, isAuthenticated } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import { Modal, TextField } from "@mui/material";

const FollowUpAppointment = (props) => {
  const [reason, setReason] = useState("");
  const [time, setTime] = useState(null);
  const [date, setDate] = useState(null);
  const [success, setSuccess] = useState(false);
  const userData = useUserData();
  const token = userData?.access_token;

  const submitAppointment = async () => {
    if (!reason || !time || !date) return;
    // Setting up appnt date
    let newDate = new Date(date);
    const year = newDate.getFullYear();
    let month = newDate.getMonth() + 1;
    let dates = newDate.getDate();
    month = month < 10 ? `0${month}` : month;
    dates = dates < 10 ? `0${dates}` : dates;
    newDate = `${year}-${month}-${dates}T${time}:00`;

    // payload
    let payload = {
      consumerUuid: props.uuid,
      uuid: isAuthenticated().uuid,
      insuranceName: "",
      appointment: {
        appntStatus: "confirmed",
        reason: reason,
        appntDate: newDate,
      },
    };
    const response = await createAppointment(payload, token);
    if (response !== "ERROR") setSuccess(true);
    else alert("SOMETHING WENT WRONG");
  };
  if (success) return <SuccessModal onClose={props.onClose} />;
  return (
    <Modal onClose={props.onClose} open={true}>
      <div className="reschedule-followup-modal">
        <div className="rfm-title">Folow-up Appointment</div>
        <div className="rfm-header">
          <div className="rfm-name">
            <img
              src={placeholderLogo}
              width={30}
              height={30}
              className="rfm-logo"
              alt=""
            />
            {props.consumerFirstName} {props.consumerlastName}
          </div>
          <div>
            <img src={timeIcon} width={30} height={30} alt="" />
          </div>
          <div className="rfm-name">
            <img
              src={placeholderLogo}
              width={30}
              height={30}
              className="rfm-logo"
              alt=""
            />
            {props.providerFirstName} {props.providerLastName}
          </div>
        </div>
        <div className="rfm-timecont">
          <div className="rfm-time-title">Date</div>
          <div className="rfm-datepicker">
            <KeyboardDatePicker
              value={date}
              placeholder="DD/MM/YYYY"
              format="dd/MM/yyyy"
              onChange={(e) => setDate(e)}
            />
          </div>
        </div>
        <div className="rfm-timecont">
          <div className="rfm-time-title">Time</div>
          <TextField
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
        </div>
        <TextField
          style={{ margin: "5px auto", width: "100%" }}
          placeholder="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <button className="rfm-submit" onClick={submitAppointment}>
          Confirm Follow-up Appointment
        </button>
      </div>
    </Modal>
  );
};

export default FollowUpAppointment;
